import React, { Fragment, useState } from "react"
import PropTypes from "prop-types"
import { MdLaunch } from "react-icons/md"
import { Badge, Link } from "gatsby-interface"
import {
  SettingsCardEditButton,
  SettingsCardContent,
} from "@modules/site/settings"
import { useTracker } from "@modules/analytics"
import SiteDetailsForm from "./SiteDetailsForm"
import { SiteSettingsSection } from "../constants"
import SiteSettingsSectionCard from "./SiteSettingsSectionCard"
import { SettingsDetailsRow } from "@modules/ui/components/SettingsDetailsRow"

function SiteDetails({
  siteName,
  repositoryUrl,
  sitePreviewDirectory = `/`,
  siteId,
  productionBranch,
  siteDescription,
  sitePrefix,
}) {
  const { trackButtonClicked } = useTracker()
  const siteDirectory = sitePreviewDirectory || `/`
  const [formVisible, setFormVisible] = useState(false)

  return (
    <SiteSettingsSectionCard id={SiteSettingsSection.SiteDetails}>
      {!formVisible && (
        <SettingsCardEditButton
          data-cy="site-details-edit-button"
          onClick={() => {
            trackButtonClicked(`Edit site details`, {
              siteId,
              uiSource: `Site Settings - Site Details`,
            })
            return setFormVisible(!formVisible)
          }}
        />
      )}
      <SettingsCardContent
        css={theme => ({
          display: `grid`,
          gridGap: theme.space[5],
        })}
      >
        {!formVisible ? (
          <Fragment>
            <SettingsDetailsRow label="Name" data-cy="site-details-name-row">
              {siteName}
            </SettingsDetailsRow>

            <SettingsDetailsRow label="Prefix">{sitePrefix}</SettingsDetailsRow>

            <SettingsDetailsRow
              label="Repository"
              data-cy="site-details-repository-row"
            >
              {repositoryUrl ? (
                <Link href={repositoryUrl}>
                  {repositoryUrl.split("//")[1]}
                  <MdLaunch />
                </Link>
              ) : (
                <Badge variant="STATUS" tone="DANGER">
                  UNAVAILABLE
                </Badge>
              )}
            </SettingsDetailsRow>

            <SettingsDetailsRow
              label="Production branch"
              data-cy="site-details-production-branch-row"
            >
              {productionBranch}
            </SettingsDetailsRow>
            <SettingsDetailsRow
              label="Base directory"
              data-cy="site-details-base-directory-row"
            >
              {siteDirectory}
            </SettingsDetailsRow>
            <SettingsDetailsRow
              label="Description"
              data-cy="site-details-base-directory-row"
            >
              <span css={{ wordBreak: `break-word` }}>
                {siteDescription || <i>No description provided</i>}
              </span>
            </SettingsDetailsRow>
          </Fragment>
        ) : (
          <SiteDetailsForm
            siteId={siteId}
            setFormVisible={() => setFormVisible(false)}
            productionBranch={productionBranch}
            siteDirectory={siteDirectory}
            siteDescription={siteDescription}
            repositoryUrl={repositoryUrl}
            siteName={siteName}
            sitePrefix={sitePrefix}
          />
        )}
      </SettingsCardContent>
    </SiteSettingsSectionCard>
  )
}

SiteDetails.propTypes = {
  siteId: PropTypes.string.isRequired,
  siteName: PropTypes.string.isRequired,
  repositoryUrl: PropTypes.string.isRequired,
  sitePreviewDirectory: PropTypes.string,
}

export default SiteDetails
